/* eslint-disable jsx-a11y/media-has-caption */
import { Card, CardContent, CardMedia, Icon, makeStyles, Theme, Typography } from '@material-ui/core';
import { capitalizeAll, GenericMessageBox } from '@moderepo/mode-app-components';
import clsx from 'clsx';
import React, { CSSProperties } from 'react';
import { ActlyzerEventVideoInfo } from '.';
import { useRitzTranslation } from '../../../../../utils/customHooks';
import { useSelectProject } from '../../../../../utils/dataStateHooks';
import { getDateTimeDisplay } from '../../../../containerUtils';


const useStyle = makeStyles((theme: Theme) => {
    return {
        root: {
            display      : 'flex',
            flexDirection: 'column',

        },

        cardMedia: {
            height: '100%',
            flex  : 1,
        },

        noVideosMessage: {
            minHeight     : 100,
            height        : '100%',
            flex          : 1,
            display       : 'flex',
            alignItems    : 'center',
            justifyContent: 'center',
            background    : theme.palette.background.default,
        },

        cameraInfo: {
            display       : 'flex',
            flexDirection : 'row',
            alignItems    : 'center',
            justifyContent: 'flex-start',
            '& .camera-id': {
                marginLeft: theme.spacing(1),
            },
        },

        cardContent: {
        },

        video: {
            width  : '100%',
            height : '100%',
            display: 'block',
            zIndex : 1,
        },
    };
}, { name: 'ActlyzerEventVideoCard', index: 1 });


export interface ActlyzerEventVideoCardProps {
    readonly className?: string | undefined;
    readonly style?: CSSProperties | undefined;
    readonly projectId: number;
    readonly videoInfo: ActlyzerEventVideoInfo;
}


/**
 * This is a component that show 1 video based on the provided videoInfo
 */
export const ActlyzerEventVideoCard: React.FC<ActlyzerEventVideoCardProps> = (props: ActlyzerEventVideoCardProps) => {
    const project = useSelectProject(props.projectId);
    const { trans } = useRitzTranslation(project);
    const classes = useStyle();

    return (
        <Card
            className={clsx(props.className, classes.root)}
            style={props.style}
            elevation={2}
        >
            <CardMedia className={classes.cardMedia}>
                {props.videoInfo.videoUrl ? (
                    <video
                        className={classes.video}
                        controls={true}
                        preload="metadata"
                        poster={props.videoInfo.thumbnail}
                    >
                        <source src={props.videoInfo.videoUrl} />
                    </video>
                ) : (
                    <GenericMessageBox
                        className={classes.noVideosMessage}
                        icon="videocam_off"
                        iconColor="error"
                        title={trans('generic.no_data.title', {
                            term: capitalizeAll(trans('label.video', { count: 2 })),
                        })}
                    />
                )}
            </CardMedia>
            <CardContent className={classes.cardContent}>
                <div className={classes.cameraInfo}>
                    {props.videoInfo.videoUrl ? (
                        <Icon>videocam</Icon>
                    ) : (
                        <Icon>videocam_off</Icon>
                    )}
                    <span className="camera-id">
                        {props.videoInfo.cameraId !== undefined
                            ? props.videoInfo.cameraId
                            : trans('generic.no_data.title', { term: trans('label.video', { count: 2 }) })}
                    </span>
                </div>
                <Typography variant="subtitle1">
                    {getDateTimeDisplay(props.videoInfo.startTime, trans)}
                </Typography>
            </CardContent>
        </Card>
    );
};
